import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IngresoActivoFijoFuncionario } from 'src/app/models/RegistroActivoFijoFuncionario.model';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from '../../shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { RegistroIngSalActivoFijo } from 'src/app/shared/models/registroIngSalActivoFijo.model';
import { RegistroActivosFijosModalComponent } from './mostrar-info-activo-fijo-modal/mostrar-info-activo-fijo-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivoFijoModel } from 'src/app/models/activoFijo.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { ingSalActivoFijo } from 'src/app/models/IngSalActivoFijo.model';
import { IfStmt } from '@angular/compiler';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';


@Component({
  selector: 'app-registro-activos-fijos',
  templateUrl: './registro-activos-fijos.component.html',
  styleUrls: ['./registro-activos-fijos.component.scss']
})
export class RegistroActivosFijosComponent implements OnInit {

  public listaActivosFijo: RegistroIngSalActivoFijo[] = [];
  funcionario: IngresoActivoFijoFuncionario;
  public activosFijosFuncionario: ActivoFijoModel[];
  public activosFijosFuncionarioPropioMen: ingSalActivoFijo[];
  public Pantalla;
  public tipoActivo: string;
  tipo: string;
  dominios: any[];
  public registroActivosFijos: any;
  public banderaModal: boolean;
  public sedeSeleccionada: string;
  // public envioData: any;


  constructor(
    private route: ActivatedRoute, private global: GlobalService, private urlService: UrlService,
    private spinner: NgxSpinnerService, private alertService: AlertService, private modalService: NgbModal) {
    this.activosFijosFuncionario = [];
    this.sedeSeleccionada = null;
    this.funcionario = new IngresoActivoFijoFuncionario();
    const datos = this.global.zonaCompartida[VariablesZonaCompartida.DATOS_FUNCIONARIO_ACTIVO_FIJO];
    this.funcionario = JSON.parse(datos ? datos.objeto : null);
    this.listaActivosFijo = [];
    this.tipo = datos ? datos.tipo : null;
    this.dominios = [];
    this.Pantalla = ConstantesService.PANTALLA_INGRESO_SALIDA_FUNCIONARIO;
    this.tipoActivo = DominiosService.ACTIVO_MEN;
    this.banderaModal = false;
  }

  ngOnInit() {
    this.consultarActivos();
  }

  limpiarObjeto() {
    this.global.zonaCompartida[VariablesZonaCompartida.DATOS_FUNCIONARIO_ACTIVO_FIJO] = undefined;
  }

  consultarActivos(numeroSerial?: string) {
    this.activosFijosFuncionarioPropioMen = undefined;
    if (this.tipoActivo && this.tipoActivo != null) {
      if (this.tipoActivo == DominiosService.ACTIVO_MEN) {
        this.consultarActivosFijosFuncionarioMen(DominiosService.ACTIVO_MEN, numeroSerial);
      } else {
        this.consultarActivosFijosFuncionarioMen(DominiosService.ACTIVO_PROPIO, numeroSerial);
      }
    }
    // else{
    //   this.consultarActivosFijosFuncionarioMen('AMBOS',numeroSerial);
    // }
  }

  /**
   * 
   * @param event
   * @author damunoz
   * 
   * metodo para obtener todos los activos del men asignados a un funcionario
   */
  consultarActivosFijosFuncionarioMen(propioMen: string, numeroSerial?: string) {
    this.spinner.show();
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    if (numeroSerial && numeroSerial != null) {
      queryParams.push(['numeroSerialPlaca', numeroSerial]);
      // if (propioMen && propioMen == ConstantesService.ACTIVO_MEN) {
      //   queryParams.push(['propioMen', ConstantesService.ACTIVO_MEN_SIN_REGISTRO]);
      // } else {
      // }
    }
    queryParams.push(['propioMen', propioMen]);
    // else {
    //   queryParams.push(['propioMen', propioMen]);
    // }
    queryParams.push(['numDocFuncionario', this.funcionario.numeroIdFuncionario]);
    queryParams.push(['tipoDocFuncionario', this.funcionario.tipoIdFuncionario]);
    const serviceProvider = 'consultarActivosPropiosMen';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.postGenerico(url).subscribe(
      data => {
        if (data && data.length > 0) {
          this.activosFijosFuncionarioPropioMen = [];
          data.forEach(element => {
            var temporal: ingSalActivoFijo = new ingSalActivoFijo();
            temporal.clasificacion = element.perteneceA;
            temporal.descripcion = element.tipoActivoFijo;
            temporal.marca = element.marcaActivoFijo;
            temporal.serialActivoFijo = element.serialActivoFijo;
            temporal.numeroIngresos = element.numeroIngresos;
            temporal.observaciones = element.DescripcionActivoFijo;
            temporal.fechaUltimoIngreso = element.fechaUltimoIngreso;
            temporal.estado = element.estadoActivoFijo;
            temporal.sede = element.sede;
            temporal.idRegIngSalActivoFijo = element.idRegIngSalActivoFijo;
            temporal.idActivo = element.idActivoFijo;
            temporal.placaInventario = element.placaInventario;
            temporal.tipoIdFuncionario = element.tipoIdFuncionario;
            temporal.numeroIdFuncionario = element.numeroIdFuncionario;
            temporal.fechaUltimaSalida = element.fechaUltimaSalida;
            temporal.nombreCompletoFuncionario = element.nombreCompletoFuncionario;
            temporal.banderaAutorizado = element.banderaAutorizado;
            if (this.tipoActivo == DominiosService.ACTIVO_MEN) {
              if (temporal.numeroIdFuncionario === this.funcionario.numeroIdFuncionario
                && temporal.tipoIdFuncionario === this.funcionario.tipoIdFuncionario) {
                temporal.asignadoAutorizado = DominiosService.ACTIVO_FIJO_ASIGNADO;
                temporal.nombreCompletoFuncionario = null;
              } else {
                temporal.asignadoAutorizado = DominiosService.ACTIVO_FIJO_AUTORIZADO;
              }
              if (temporal.banderaAutorizado) {
                this.handlerActivoSeleccionado({ temporal }, element);
              } else if (!temporal.banderaAutorizado) {
                this.activosFijosFuncionarioPropioMen.push(temporal);
              }
            } else {
              this.activosFijosFuncionarioPropioMen.push(temporal);
            }

            this.funcionario.correo = element.correo;
          });
          this.spinner.hide();
        } else {

        }
        this.spinner.hide();
      }, err => {
        this.catchExceptione(err);
      }
    );

  }

  catchExceptione(error) {
    this.spinner.hide();
    if (error && error.error) {
      this.alertService.generateAlertError(error.error.message, 'Error');
    } else {
      this.alertService.generateAlertError('Se presento un error registrando el ingreso', 'Error');
    }
  }

  // /**
  //  * 
  //  * @param event
  //  * @author damunoz
  //  * 
  //  * metodo para obtener todos los activos propios de un funcionario
  //  */ 
  // consultarActivosPropiosFuncionario(numeroSerial?: string){
  //   this.spinner.show();
  //   const queryParams: Array<[string, string]> = new Array<[string, string]>();
  //   queryParams.push(['propioMen', ConstantesService.ACTIVO_PROPIO]);
  //   queryParams.push(['numDocFuncionario', this.funcionario.numeroIdFuncionario]);
  //   queryParams.push(['tipoDocFuncionario', this.funcionario.tipoIdFuncionario]);
  //   const serviceProvider = 'consultarActivosPropiosMen';
  //   const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI);
  //   this.global.postGenerico(url).subscribe(
  //     data => {
  //       if (data && data.length > 0) {
  //         data.forEach(element => {
  //           var temporal: ingSalActivoFijo=new ingSalActivoFijo();
  //           temporal.clasificacion=element.perteneceA;
  //           temporal.descripcion=element.tipoActivoFijo;
  //           temporal.marca=element.marcaActivoFijo;
  //           temporal.serialActivoFijo=element.serialActioFijo;
  //           temporal.numeroIngresos=element.numeroIngresos;
  //           temporal.observaciones=element.DescripcionActivoFijo;
  //           temporal.fechaUltimoIngreso=element.fechaUltimoIngreso;
  //           temporal.estado=element.estadoActivoFijo;
  //           temporal.sede=element.sede;
  //           temporal.idRegIngSalActivoFijo=element.idRegIngSalActivoFijo;
  //           temporal.idActivoFijo=element.idActivoFijo;
  //           temporal.placaInventario=element.placaInventario;
  //           temporal.tipoDocumentoFuncionario=element.tipoDocumentoFuncionario;
  //           temporal.numeroDocumentoFuncionario=element.numeroDocumentoFuncionario;
  //           temporal.fechaUltimaSalida=element.fechaUltimaSalida;
  //           this.activosFijosFuncionarioPropioMen.push(temporal);
  //         });
  //         this.spinner.hide();
  //       }
  //       this.spinner.hide();
  //     }, err => {
  //       this.cathException('No es posible consultar los activos propios del funcionario', err);
  //     }
  //   );
  // }



  // Holman Gonzalez
  // modified by: fromero
  // 14/06/2019
  // metodo que consulta un activo por placa de inventario

  consultarActivoFijo(event: any) {
    this.spinner.show();
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filtroBuscarActivoFijo', event]);
    queryParams.push(['numDocFunc', this.funcionario.numeroIdFuncionario]);
    queryParams.push(['tipDocFunc', this.funcionario.tipoIdFuncionario]);
    const serviceProvider = 'ObtenerIngresoSalidaActivosFijo';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.postGenerico(url).subscribe(
      data => {


        if (data && data.length > 0) {
          this.listaActivosFijo = data;

          this.activosFijosFuncionario = [];
          data.forEach(element => {

            const temp: ActivoFijoModel = new ActivoFijoModel(
              element.idActivo,
              element.tipoDocumentoFuncionario,
              element.numeroDocumentoFuncionario,
              element.tipoActivoFijo,
              element.serialActioFijo,
              element.DescripcionActivoFijo,
              element.estadoActivoFijo,
              element.clasificacionActivoFijo,
              null,
              element.marcaActivoFijo,
              element.placainventario,
              null,
              element.observacionesActivoFijo,
              element.perteneceA,
              null,
              false,
              false,
              null,
              null,
              'Funcionarios',
              null);

            if (temp.numeroIdFuncionario !== this.funcionario.numeroIdFuncionario) {
              temp.clasificacion = 'AUTORIZADO';
            }
            this.activosFijosFuncionario.push(temp);
          });
          this.spinner.hide();
        } else {
          this.alertService.generateAlertError(ConstantesService.FILTRO_ACTIVOS_NO_ENCONTRADO, '');
        }
        this.spinner.hide();
      }, err => {
        this.catchException('No es posible Consultar los activos fijos', err);
      }
    );
    this.consultarActivos(event);
  }

  // holman gonzalez
  // consulta de activos fijos del funcionario
  // 10/06/2019
  consultarActivosFijosFuncionario() {
    this.spinner.show();
    const serviceProvider = 'ObtenerActivoFijoFuncionario';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filtroBuscarActivoFijo', this.funcionario.numeroIdFuncionario]);
    queryParams.push(['numDocFunc', this.funcionario.numeroIdFuncionario]);
    queryParams.push(['tipDocFunc', this.funcionario.tipoIdFuncionario]);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url).subscribe(
      (data: RegistroIngSalActivoFijo[]) => {

        this.activosFijosFuncionario = [];
        data.forEach(el => {

          const temp: ActivoFijoModel = new ActivoFijoModel(
            el.idActivo
            , ''
            , el.numeroDocumentoFuncionario
            , el.tipoActivoFijo
            , el.serialActioFijo
            , el.DescripcionActivoFijo
            , el.estadoActivoFijo
            , el.clasificacionActivoFijo
            , ''
            , el.marcaActivoFijo
            , 'pendiente placa'
            , ''
            , el.observacionesActivoFijo
            , el.propietarioActivoFijo
            , ''
            , null
            , false
            , null
            , null
            , 'Funcionarios'
            , 'pendiente sede'
          );

          this.activosFijosFuncionario.push(temp);


        });
        this.spinner.hide();
      }, err => {
        this.catchException('No es posible Consultar los activos fijos', err);
      }
    );
  }

  // fromero:
  // método para inyectar un componente dentro del modal,
  // se envía componente y opciones de modal
  // 14/05/2019
  public vermodal(event: any) {
    const modalRef = this.modalService.open(RegistroActivosFijosModalComponent,
      { centered: true, windowClass: 'myCustomModalClass' });


    if (event.Activo) {

      const act = event.Activo;
      const objTemp = new RegistroIngSalActivoFijo(act.clasificacion, act.descripcion, act.descripcion, act.serialActivoFijo,
        act.estado, act.nombreCompletoFuncionario, act.observaciones, act.marca, act.idActivo, act.numeroIdFuncionario,
        act.clasificacion, act.serialActivoFijo, null, act.observaciones, act.fechaUltimoIngreso, act.sede, null, act.idActivo
        , act.placaInventario, act.tipoIdFuncionario, act.fechaUltimaSalida);

      modalRef.componentInstance.registroActivosFijos = [objTemp];
      modalRef.result.then((result) => {
        this.handlerModal(result, event);
      });
    }
    else if (event) {
      const obj = [event]
      modalRef.componentInstance.registroActivosFijos = obj;
      modalRef.result.then((result) => {
        if (event.estadoActivoFijo == 'ING') {
          event.Accion = 'Retirar';
          event.estadoActivoFijo = 'RET';
        } else {
          event.Accion = 'Ingresar';
          event.estadoActivoFijo = 'ING';
        }
        if (result.observacionesDiligenc) {
          event.observaciones = result.observacionesDiligenc;
        }
        this.handlerModal(result, event);
      });
    }

    //this.listaActivosFijo; // Objeto que se envìa al modal para ediciòn


  }

  // fromero
  // 15/06/2019
  // hgandler para el resultado del modal

  handlerModal(resultado, event) {
    if (resultado.respuesta === 'Accept') {
      if (event.Activo && event.Activo != null) {
        this.registrarIngresoSalidaActivoFijo(event.Activo, event.Accion, undefined, resultado.observacionesDiligenc);
      } else if (event.temporal && event.temporal != null) {
        this.registrarIngresoSalidaActivoFijo(event.temporal, event.Accion, undefined,resultado.observacionesDiligenc);
      } else if (event && event != null) {
        this.registrarIngresoSalidaActivoFijo(event, event.Accion, undefined, resultado.observacionesDiligenc);
      }
    }
  }

  /**
   * 
   * @param event 
   */
  handlerTipoActivo(event) {
    this.tipoActivo = event;
    this.consultarActivos();
  }

  // fromero
  // 13/06/2019
  // handler de  activo seleccionado para realizar registro

  handlerActivoSeleccionado(event, temporal?) {
    this.banderaModal = false;
    if (event.temporal) {
      if (event.temporal.numeroIdFuncionario === this.funcionario.numeroIdFuncionario
        && event.temporal.tipoIdFuncionario === this.funcionario.tipoIdFuncionario) {
        event.temporal.asignadoAutorizado = DominiosService.ACTIVO_FIJO_ASIGNADO;
        if (event.Accion === 'Ingresar') {
          this.registrarIngresoSalidaActivoFijo(temporal, event.Accion);
        } else if (event.Accion === 'Retirar') {
          this.registrarIngresoSalidaActivoFijo(temporal, event.Accion);
        }
      } else {
        event.temporal.asignadoAutorizado = DominiosService.ACTIVO_FIJO_AUTORIZADO;
        this.banderaModal = true;
        this.vermodal(temporal);
      }
    }
    if (event.Activo) {
      if (event.Activo.numeroIdFuncionario === this.funcionario.numeroIdFuncionario
        && event.Activo.tipoIdFuncionario === this.funcionario.tipoIdFuncionario) {
        event.Activo.asignadoAutorizado = DominiosService.ACTIVO_FIJO_ASIGNADO;
        if (event.Accion === 'Ingresar') {
          this.registrarIngresoSalidaActivoFijo(event.Activo, event.Accion);
        } else if (event.Accion === 'Retirar') {
          this.registrarIngresoSalidaActivoFijo(event.Activo, event.Accion);
        }
      } else {
        event.Activo.asignadoAutorizado = DominiosService.ACTIVO_FIJO_AUTORIZADO;
        this.banderaModal = true;
        this.vermodal(event);
      }
    }
  }


  // fromero
  // 13/06/2019
  // Registrar Ingreso o Salida de un Activo fijo

  registrarIngresoSalidaActivoFijo(objeto: any, accion, enviarCorreo?: string, observaciones?: string) {
    this.spinner.show();
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    let serviceProvider = '';
    let msjError = null;
    if (accion === 'Ingresar') {
      serviceProvider = 'RegistrarIngresoActivoFijoFuncionario';
      msjError = 'No fue posible registrar el ingreso del activo';
      if (this.banderaModal) {
        queryParams.push(['enviarCorreo', 'SI']);
      }
    } else {
      serviceProvider = 'RegistrarSalidaActivoFijoFuncionario';
      msjError = 'No fue posible registrar la salida del activo';
      if (this.banderaModal) {
        queryParams.push(['enviarCorreo', 'SI']);
      }
    }

    const activo: IngresoActivoFijoFuncionario = new IngresoActivoFijoFuncionario();
    if (objeto.idActivo) { activo.idActivo = parseInt(objeto.idActivo, null); } else { activo.idActivo = objeto.idActivoFijo; }
    activo.tipoIdFuncionario = this.funcionario.tipoIdFuncionario;
    activo.numeroIdFuncionario = this.funcionario.numeroIdFuncionario;
    if (objeto.tipo) { activo.tipo = objeto.tipo; } else { activo.tipo = objeto.clasificacionActivoFijo; }
    activo.idUsuarioSIA3 = parseInt(sessionStorage.getItem(ConstantesService.SIA3_SESSSION));
    activo.serialActivoFijo = objeto.serialActivoFijo;
    if (objeto.descripcion) { activo.descripcion = objeto.descripcion; } else { activo.descripcion = objeto.DescripcionActivoFijo; }
    activo.estado = objeto.estado;
    if (objeto.clasificacion) { activo.clasificacion = objeto.clasificacion; } else {
      activo.clasificacion = objeto.clasificacionActivoFijo;
    }
    activo.cual = null;
    if (activo.marca) { activo.marca = objeto.marca; } else { activo.marca = objeto.marcaActivoFijo; }
    activo.placaInventario = objeto.placaInventario;
    activo.autorizadoPor = null;
    activo.observaciones = objeto.observaciones;
    if (objeto.clasificacion) { activo.perteneceA = objeto.clasificacion; } else { activo.perteneceA = objeto.perteneceA; }
    activo.estadoActivo = null;
    if (objeto.sede && objeto.sede != null) { activo.sede = objeto.sede; } else { if (this.sedeSeleccionada && this.sedeSeleccionada != null) { activo.sede = this.sedeSeleccionada; } }

    activo.observacionesIngresoSalida = observaciones;

    //temporal.clasificacion=element.perteneceA;
    //temporal.descripcion=element.tipoActivoFijo;
    //         temporal.marca=element.marcaActivoFijo;
    //         temporal.serialActivoFijo=element.serialActioFijo;
    //         temporal.numeroIngresos=element.numeroIngresos;
    //         temporal.observaciones=element.DescripcionActivoFijo;
    //         temporal.fechaUltimoIngreso=element.fechaUltimoIngreso;
    //         temporal.estado=element.estadoActivoFijo;
    //         temporal.sede=element.sede;
    //         temporal.idRegIngSalActivoFijo=element.idRegIngSalActivoFijo;
    //         temporal.idActivo=element.idActivoFijo;
    //         temporal.placaInventario=element.placainventario;
    //         temporal.tipoDocumentoFuncionario=element.tipoDocumentoFuncionario;
    //         temporal.numeroDocumentoFuncionario=element.numeroDocumentoFuncionario;
    //         temporal.fechaUltimaSalida=element.fechaUltimaSalida;

    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.postGenerico(url, activo).subscribe(
      data => {
        if (data.mensaje[0] == 'R') {
          this.alertService.generateAlertSuccess('Retiro del elemento registrado con éxito', '');
        } else {
          this.alertService.generateAlertSuccess('Ingreso del elemento registrado con éxito', '');
        }
        this.consultarActivosFijosFuncionario();
        this.consultarActivosFijosFuncionarioMen(objeto.clasificacion);
        this.spinner.hide();
      }, err => {
        this.catchException(msjError, err);
      }
    );
  }

  catchException(error, err) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }

  // fromero
  // 15/06/2019
  //  guarda un nuevo registro de activo fijo
  guardarActivoNuevo(event) {
    this.spinner.show();
    const serviceProvider = 'CrearActivoFijoFuncionario';
    const activo = {
      idActivo: null,
      tipoIdFuncionario: this.funcionario.tipoIdFuncionario,
      numeroIdFuncionario: this.funcionario.numeroIdFuncionario,
      tipo: event.activoFijoVisitanteDTO.tipoTecnologia,
      serialActivoFijo: event.activoFijoVisitanteDTO.numeroSerial,
      descripcion: event.activoFijoVisitanteDTO.descripcion,
      estado: null,
      clasificacion: event.activoFijoVisitanteDTO.tipoTecnologia,
      cual: null,
      marca: event.activoFijoVisitanteDTO.marca,
      placaInventario: event.activoFijoVisitanteDTO.numeroSerial,
      autorizadoPor: null,
      observaciones: event.activoFijoVisitanteDTO.descripcion,
      perteneceA: null,
      estadoActivo: 'INGRESADO',
      sede: event.hisActivoFijoVisitanteDTO.sede,
      idUsuarioSIA3: parseInt(sessionStorage.getItem(ConstantesService.SIA3_SESSSION))
    };

    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
    this.global.postGenerico(url, activo).subscribe(
      data => {
        this.consultarActivosFijosFuncionario();
        this.spinner.hide();
        this.alertService.generateAlertSuccess(data.mensaje, '');
        this.consultarActivosFijosFuncionarioMen(DominiosService.ACTIVO_PROPIO);
      }, err => {
        this.catchException('Error al registrar el activo fijo', err);
      }
    );
  }


  handlerSede(event) {
    this.sedeSeleccionada = event;
  }
}
